import { createService, z } from '@bonanza-social/toolkit/api';
import {
  RegisterSchema,
  BiometricsStartSchema,
  BiometricsFinishSchema,
} from './BiometricsService.schemas';

export default {
  ...createService(
    {
      enable: {
        method: 'POST',
        url: '/credentials',
        responseSchema: RegisterSchema,
      },
      disable: {
        method: 'DELETE',
        url: ({ credentialId }: { credentialId: number }) =>
          `/credentials/${credentialId}`,
        responseSchema: z.any(),
      },
    },
    ({ userId }) => `/accounts/${userId}/biometrics`,
  ),
  ...createService({
    start: {
      method: 'POST',
      url: ({ accountId }: { accountId: number }) =>
        `/accounts/${accountId}/biometrics/auth/start`,
      responseSchema: BiometricsStartSchema,
    },
    finish: {
      method: 'POST',
      url: ({ accountId }: { accountId: number }) =>
        `/accounts/${accountId}/biometrics/auth/finish`,
      responseSchema: BiometricsFinishSchema,
    },
  }),
};
